'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dekuRedux = require('@viskan/deku-redux');

var _actions = require('./actions');

var _components = require('./components');

var _components2 = _interopRequireDefault(_components);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var component = (0, _dekuRedux.connect)(function (_ref, _ref2) {
	var cms = _ref.cms,
	    cmsComponents = _ref.cmsComponents;
	var id = _ref2.id;
	return {
		configuration: cmsComponents.slideout01.configuration[id],
		open: cmsComponents.slideout01[id]
	};
}, function (dispatch, _ref3) {
	var id = _ref3.id;
	return {
		setStateConfiguration: function setStateConfiguration(configuration) {
			return dispatch((0, _actions.setStateConfiguration)({ configuration: configuration, id: id }));
		},
		toggle: function toggle(opts) {
			return dispatch((0, _actions.toggle)({ id: id, opts: opts }));
		}
	};
})(_components2.default);

exports.default = { component: component, config: _config2.default };